import { defineStore } from 'pinia'
let brandRequest, urlRequest
async function fetchJSON(path) {
  const response = await fetch(path, { cache: 'no-cache', signal: AbortSignal.timeout(15000) })
  if (!response.ok) throw new Error(`Unable to load data (${response.status})`)
  return response.json()
}
export const useCommonStore = defineStore('common', {
  state: () => ({ brandData: {}, url: {}, brandsLoaded: false, urlsLoaded: false, displayDate: new Date().toISOString() }),
  actions: {
    async getBrandData(force = false) {
      if (this.brandsLoaded && !force) return this.brandData
      if (!brandRequest) brandRequest = fetchJSON('/JSON/brandData.json').finally(() => { brandRequest = null })
      this.brandData = await brandRequest
      this.brandsLoaded = true
      return this.brandData
    },
    async getUrl() {
      if (this.urlsLoaded) return this.url
      if (!urlRequest) urlRequest = fetchJSON('/JSON/url.json').finally(() => { urlRequest = null })
      this.url = await urlRequest
      this.urlsLoaded = true
      return this.url
    }
  }
})
